// extracted by mini-css-extract-plugin
export var productImage = "_pr-1";
export var viewLink = "_pr-2";
export var wishlistItem = "_pr-0";